export const FocusDirective = {

    mounted: (el, binding) => {
        el.focus();
    }    
}